// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"rental-details_itemTitle__aPdO0","itemContainer":"rental-details_itemContainer__fkzxZ"};